<div id="news_detail">
    <p style="text-align: center">
        <span style="font-size: 16px"><u><a href="http://bichvan.vn/"><span style="font-family: 'times new roman', times, serif">Nhà phân phối hàng đầu ống nhựa Tiền Phong</span></a>
        </u>
        </span>
    </p>
    <p>
        &nbsp;</p>
    <p style="text-align: center">
        <span style="color: rgb(105,105,105)"><span style="font-family: 'times new roman', times, serif"><span style="font-size: 14px"><strong>Khách Mua Lẻ</strong></span></span>
        </span>
    </p>
    <p align="center">
        <span style="color: rgb(105,105,105)"><span style="font-family: 'times new roman', times, serif"><span style="font-size: 14px">Cửa hàng đặt tại trung tâm TP Hải Phòng</span></span>
        </span>
    </p>
    <p align="center">
        <span style="color: rgb(105,105,105)"><span style="font-family: 'times new roman', times, serif"><span style="font-size: 14px">Đội ngũ nhân viên nhiệt tình, nhiều kinh nghiệm</span></span>
        </span>
    </p>
    <p align="center">
        <span style="color: rgb(105,105,105)"><span style="font-family: 'times new roman', times, serif"><span style="font-size: 14px">Thủ tục nhanh chóng, luôn kèm theo hóa đơn</span></span>
        </span>
    </p>
    <p align="center">
        <span style="color: rgb(105,105,105)"><span style="font-family: 'times new roman', times, serif"><span style="font-size: 14px">Dịch vụ vận chuyển theo yêu cầu của khách</span></span>
        </span>
    </p>
    <p align="center">
        <span style="color: rgb(105,105,105)"><span style="font-family: 'times new roman', times, serif">~~~~~</span></span>
    </p>
    <p align="center">
        <span style="color: rgb(105,105,105)"><span style="font-family: 'times new roman', times, serif"><span style="font-size: 14px"><strong>Cửa Hàng và Công Trình</strong></span></span>
        </span>
    </p>
    <p align="center">
        <span style="color: rgb(105,105,105)"><span style="font-family: 'times new roman', times, serif"><span style="font-size: 14px">Đặt hàng dễ dàng</span></span>
        </span>
    </p>
    <p align="center">
        <span style="color: rgb(105,105,105)"><span style="font-family: 'times new roman', times, serif"><span style="font-size: 14px">Thủ tục nhanh chóng</span></span>
        </span>
    </p>
    <p align="center">
        <span style="color: rgb(105,105,105)"><span style="font-family: 'times new roman', times, serif"><span style="font-size: 14px">Chiết khấu hợp lý</span></span>
        </span>
    </p>
    <p align="center">
        <span style="color: rgb(105,105,105)"><span style="font-family: 'times new roman', times, serif"><span style="font-size: 14px">Vận chuyển tận nơi</span></span>
        </span>
    </p>
    <p align="center">
        <span style="color: rgb(105,105,105)"><span style="font-family: 'times new roman', times, serif">~~~~~&nbsp;</span></span>
    </p>
    <p align="center">
        <span style="color: rgb(105,105,105)"><span style="font-family: 'times new roman', times, serif"><span style="font-size: 16px"><strong style="font-size: 12px">Miễn Phí Vận Chuyển Ống Nhựa Đến Chân Công Trình và Dự Án trên Địa Bàn Toàn Quốc</strong></span></span>
        </span>
    </p>
    <p align="center">
        &nbsp;</p>
    <p align="center">
        <span style="color: rgb(105,105,105)"><span style="font-family: 'times new roman', times, serif"><strong style="font-size: 12px"><img alt="" src="/upload/images/IMG_9120.JPG" style="width: 600px; height: 400px"></strong></span></span>
    </p>
    <p>
        &nbsp;</p>
    <p>
        <span style="color: rgb(105,105,105)"><span style="font-family: 'times new roman', times, serif"><span style="font-size: 14px">Trong gần hai thập niên qua, công ty TNHH TM Bích Vân vinh hạnh là nhà cung cấp vật tư ngành nước cho hàng ngàn đại lý, cửa hàng và công trinh lớn nhỏ ở ba miền Bắc, Trung và Nam.</span></span>
        </span>
    </p>
    <p>
        <span style="color: rgb(105,105,105)"><span style="font-family: 'times new roman', times, serif"><span style="font-size: 14px">&nbsp;</span></span>
        </span>
    </p>
    <p>
        <span style="color: rgb(105,105,105)"><span style="font-family: 'times new roman', times, serif"><span style="font-size: 14px"><strong>Một số công trình tiêu biểu mà chúng tôi được hân hạnh phục vụ:</strong></span></span>
        </span>
    </p>
    <p>
        &nbsp;</p>
    <ol>
        <li>
            <span style="color: rgb(105,105,105)"><span style="font-family: 'times new roman', times, serif"><span style="font-size: 14px">1. Công trình TIMES CITY (VINCOM)-Minh Khai, quận Hai Bà Trưng, Hà Nội</span></span>
            </span>
        </li>
        <li>
            <span style="color: rgb(105,105,105)"><span style="font-family: 'times new roman', times, serif"><span style="font-size: 14px">2. Hệ thống cấp thoát nước huyện đảo Cồn Cỏ-tỉnh Quảng Trị</span></span>
            </span>
        </li>
        <li>
            <span style="color: rgb(105,105,105)"><span style="font-family: 'times new roman', times, serif"><span style="font-size: 14px">3. Dự án: Cải tạo, sửa chữa Cảng HKQT Nội Bài, Hà Nội</span></span>
            </span>
        </li>
        <li>
            <span style="color: rgb(105,105,105)"><span style="font-family: 'times new roman', times, serif"><span style="font-size: 14px">4. Khu Công Nghiệp Visip-Thủy Nguyên, Hải Phòng</span></span>
            </span>
        </li>
        <li>
            <span style="color: rgb(105,105,105)"><span style="font-family: 'times new roman', times, serif"><span style="font-size: 14px">5 .Dự án: nhà câu lạc bộ Gôn CIPUTRA–Hà Nội</span></span>
            </span>
        </li>
        <li>
            <span style="color: rgb(105,105,105)"><span style="font-family: 'times new roman', times, serif"><span style="font-size: 14px">6. Khu đô thị mới Bắc An Khánh Hoài Đức, Hà Nội</span></span>
            </span>
        </li>
        <li>
            <span style="color: rgb(105,105,105)"><span style="font-family: 'times new roman', times, serif"><span style="font-size: 14px">7. Gói thầu EX-2 dự án đường cao tốc <u><a href="http://bichvan.vn/danh-muc-cong-trinh-va-du-an-cap-thoat-nuoc-tai-cac-khu-cong-nghiep-ctbv210.html">Hà Nội-Hải Phòng</a></u></span></span>
            </span>
        </li>
        <li>
            <span style="color: rgb(105,105,105)"><span style="font-family: 'times new roman', times, serif"><span style="font-size: 14px">8. Gói thầu B53: hệ thống thoát nước quận Liên Chiểu, Sơn Trà-Cẩm Lệ</span></span>
            </span>
        </li>
        <li>
            <span style="color: rgb(105,105,105)"><span style="font-family: 'times new roman', times, serif"><span style="font-size: 14px">9. Hệ thống xử lý nước thải cho khu đô thị Royal City-quận Thanh Xuân, Hà Nội</span></span>
            </span>
        </li>
        <li>
            <span style="color: rgb(105,105,105)"><span style="font-family: 'times new roman', times, serif"><span style="font-size: 14px">10.Thủy Điện Huội Quảng,sông Nậm Mu-Than Uyên (Lai Châu), Mường La (Sơn La)</span></span>
            </span>
        </li>
    </ol>
    <p align="center">
        &nbsp;</p>
    <p align="center">
        &nbsp;<img alt="Miễn Phí Vận Chuyển" src="/upload/images/bichvan-vn.jpg" style="width: 750px; height: 64px"></p>
    <p align="center">
        &nbsp;</p>
    <div style="text-align: center">
        <span style="color: rgb(255,140,0)"><span style="font-size: 20px"><span style="font-family: 'times new roman', times, serif">&nbsp;Công ty TNH TM Bích Vân</span></span>
        </span>
    </div>
    <div style="text-align: center">
        &nbsp;</div>
    <div style="text-align: center">
        <span style="color: rgb(105,105,105)"><span style="font-family: 'times new roman', times, serif"><span style="font-size: 16px">Nhà Phân Phối </span></span>
        </span><span style="font-family: 'times new roman', times, serif"><span style="font-size: 16px"><u><a href="http://bichvan.vn/bang-bao-gia-vat-tu-nganh-nuoc.html">Vật Tư Ngành Nước</a></u></span></span><span style="color: rgb(105,105,105)"><span style="font-family: 'times new roman', times, serif"><span style="font-size: 16px"> Hàng Đầu Việt Nam</span></span>
        </span>
    </div>
    <div style="text-align: center">
        <span style="color: rgb(105,105,105)"><span style="font-family: 'times new roman', times, serif"><span style="font-size: 14px">Hotline: 0906 066 757 &nbsp;Email: bichvan.ltd@gmail.com</span></span>
        </span>
    </div>
    <div style="text-align: center">
        &nbsp;</div>
    <div style="text-align: center">
        &nbsp;
        <a href="http://bichvan.vn/bang-gia.html"><img alt="Kho hàng ống nhựa tiền phong" src="/upload/images/kho-hang-ong-nhua-tien-phong(2).jpg" style="width: 740px; height: 462px"></a>
    </div>
    <div style="text-align: center">
        Kho Hàng <u><a href="http://bichvan.vn/bang-gia.html">Ống Nhựa</a></u> Công Ty TNHH TM Bích Vân - Ảnh chụp toàn cảnh từ Camera&nbsp;</div>
</div>